module.exports = __webpack_public_path__ + "img/exostructure.d98ec036.png";